export default {
    'AUTH.FORGET_PASSWORD.TITLE': 'Mot de passe oublié',
    'AUTH.FORGET_PASSWORD.ASIDE': 'Veuillez renseigner votre email, nous allons vous envoyer un lien pour créer un ' +
        'nouveau mot de passe.',
    'AUTH.FORGET_PASSWORD.BUTTON': 'Envoyez moi le lien',
    'AUTH.FORGET_PASSWORD.NEW.ONE': 'Votre nouveau mot de passe',
    'AUTH.FORGET_PASSWORD.NEW.TWO': 'Confirmez votre nouveau mot de passe',
};
